// --- React ---
import { useState } from "react";
import { useNavigate } from "react-router-dom";

// --- Components ---
import ModalConfirm from "../../../components/modal-comfirm";
import { useLookupParameter } from "../../../utils/get-lookup";
import { Plus } from "lucide-react";
import StationCameraModal from "../../../components/station/camera";
import { notify } from "../../../common/notificationService";
import { Pencil, Trash } from "lucide-react";

// --- Models ---
import { StationCameraItem } from "../../../models/types/stationCamera";

// --- Services ---
import stationCameraSvc from "../../../services/api/stationCamera";

interface FormProps {
  stationId: number | string;
  data: StationCameraItem[];
  onSuccess?: () => Promise<void>;
}

export default function StationCamera({ stationId, data, onSuccess }: FormProps) {
  const navigate = useNavigate();
  const { lookupParameter } = useLookupParameter();

  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [itemSelected, setItemSelected] = useState<any | null>(null);
  const [comfirmDelete, setComfirmDelete] = useState<boolean>(false);


  const handleDeleteParameter = async (id: string) => {
    setLoading(true);
    try {
      const res = await stationCameraSvc.deleteStationCamera(id);
      if (res && res.content.status) {
        onSuccess?.();
        notify("Thành công", "Xóa thành công", "success");
      }
    } catch (e: any) {
      notify("Lỗi", "Xảy ra lỗi", "danger");
    } finally {
      setComfirmDelete(false);
      setLoading(false);
    }
  };

  const handleOpenModal = (item: any | null) => {
    setItemSelected(item);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setItemSelected(null);
  };

  const handleConfirmDelete = (item: StationCameraItem | null) => {
    setComfirmDelete(true);
    setItemSelected(item);
  };

  return (
    <>
      {comfirmDelete && itemSelected && (
        <ModalConfirm
          isOpen={comfirmDelete}
          onClose={() => setComfirmDelete(false)}
          title="Xác nhận xóa"
          content={`Bạn có chắc chắn muốn xóa camera ${itemSelected?.title} không?`}
          titleComfirm="Xóa"
          action={() => handleDeleteParameter(itemSelected?.id)}
        />
      )}
      {openModal && (
        <StationCameraModal
          isOpen={openModal}
          onClose={handleCloseModal}
          data={itemSelected}
          stationId={stationId}
          onSuccess={onSuccess}
        />
      )}
      <div className="page-wrapper list min-h-[375px] bg-white rounded-md shadow-md ">
        <div className="h-full flex flex-wrap gap-2">
          {data?.map((item: StationCameraItem, index: number) => (
            <div key={index} className="border  border-gray-200 shadow-md p-4">
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <span>Tên: </span>
                  <span className="font-bold">{item.title}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span>URL: </span>
                  <span className="font-bold">{item.cameraUrl}</span>
                </div>
              </div>
              <div className="flex items-center gap-2 mt-2">
                <button
                  title="Xóa"
                  type="button"
                  className="btn bg-red-500 text-white"
                  onClick={() => handleConfirmDelete(item)}
                >
                  <Trash size={16} />
                </button>
                <button
                  title="Sửa"
                  type="button"
                  className="btn bg-blue-500 text-white"
                  onClick={() => handleOpenModal(item)}
                >
                  <Pencil size={16} />
                </button>
              </div>
            </div>
          ))}
          <div
            className="min-h-[140px] flex items-center justify-center border border-gray-200 shadow-md p-6 cursor-pointer"
            onClick={() => handleOpenModal(null)}
          >
            <div className="flex flex-col items-center">
              <Plus />
              Thêm camera
            </div>
          </div>
        </div>
      </div>
    </>
  );
}